<template>
	<div class="page-container">
		<div class="conteiner-fluid">
			<!-- <button id="addProject" class="btn btn-info"><i class="fa fa-plus"></i></button> -->
			<div class="tabla-contenedor">
				<table class="tabla-principal" id="projectTable">
					<thead>
						<tr>
							<th v-for="col in columns" :key="col.key" :class="col.class">{{ col.label }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(project, rowIndex) in paginatedRows" :key="project.id"
							:class="{ selectedRow: selected.row === rowIndex }">
							<td v-for="(col, colIndex) in columns" :key="col.key" :class="[{
								selectedCell:
									selected.row === rowIndex &&
									selected.col === colIndex &&
									col.editable
							}, col.class]" @click="col.editable && selectCell(rowIndex, colIndex)">
								<template v-if="isEditingCell(rowIndex, colIndex, col)">
									<input ref="editableInput" v-model="projectList[rowIndex][col.key]"
										@blur="stopEditing" @keydown.enter.prevent="stopEditing" class="cell-input" />
								</template>
								<template v-else>
									<div v-if="col.key == 'actions'">
										<DropdownMenu :buttonClass="['base', 'btn-actions']">
											<template v-slot:button>
												<i class="fas fa-ellipsis-v"></i>
											</template>
											<template v-slot:menu>
												<ul style="margin: 0; padding: 0; list-style: none">
													<li>
														<button>
															<i class="fas fa-edit"></i>
															Edit
														</button>
													</li>
													<li>
														<button class="text-left textAction">
															<i class="fas fa-times"></i>
															Delete
														</button>
													</li>
												</ul>
											</template>
										</DropdownMenu>
									</div>
									<div v-else-if="col.key == 'note'">
										<!-- <div style="display: flex; justify-content: center; align-items: center; gap: 5px; margin-bottom: 15px;">
											<span v-if="project.sale.sales_type=='retail'" class="badge badge-info">Retail</span>
											<span v-else class="badge badge-primary">Insurance</span>
										</div> -->
										<span class="job_id" style="display:block; text-align: center;">
											<span >Job</span>
											<span > #{{ project.sale_id }}</span>
										</span>
										<div class="diffdays" v-if="project.status_id != 3">
											<span class="nrodiff">{{project.sale.days_ago}}</span>
											<span class="labeldiff">Days in Progress</span>
										</div>
										<div class="diffdays" v-else>
											<span class="labeldiff">Completed in <span class="nrodiff">{{project.sale.days_ago}}</span> Days</span>
										</div>
										<div class="btnNotes showTootlip" style="cursor: pointer;" @click="openModal('notes', project.sale)">
											<span class="note_number">
												<span class="note_number_count">{{ project.notes_count }} </span>
												<i class="fas fa-comment-alt" :class="{'active': project.notes_count > 0}"></i>
											</span>
											<span class="addNotes" style="font-size: 10px;">(Note)</span>
											<span class="tooltip">Add/See Notes</span>
										</div>
									</div>
									<div v-else-if="col.key == 'images'">
										<div class="previewImg" v-if="project.gallery_main==null" @click="openModal('gallery', project)">
											<i class="fa fa-image"></i>
										</div>
										<div v-else class="previewImg" @click="openModal('gallery', project)">
											<img :src="urlGallery+'small/'+project.gallery_main.name" :alt="'cover'+project.id" />
										</div>
										<div class="files_drive justify-content-center text-center" style="margin-top: 0px;" >
											<span :class="['showTootlip', 'filesDrive', {'active': project.has_files_count>0}]" @click="openModal('adjuntarLinkFiles', project.sale)" style="font-size: 1.5rem;">
												<i class="fab fa-google-drive" ></i>
											</span>
											<span :class="['filePdf', 'showTootlip', {'active': project.has_pdf_count>0}]" @click="openModal('adjuntarPdf', project.sale)">
												<i class="fas fa-file-pdf"></i>
												<span class="tooltip">Attach PDF</span>
											</span>
										</div>
									</div>
									<div v-else-if="col.key == 'client'">
										<div class="profile_info" style="cursor: pointer;" @click="openModal('profile', project)">
											<div><strong style="color: #031099;">{{ project.sale.title }}</strong></div>
											<div>
												<span >{{project.profile.name}}</span>
												<span v-if="project.profile.lastname"> {{project.profile.lastname}}</span>
											</div>
											<!-- <div>{{project.profile.phone}}</div> -->
											<div>
												<span v-if="project.profile.address">{{project.profile.address}}</span>
												<span v-if="project.profile.city"> {{project.profile.city}}</span>
												<span v-if="project.profile.state">, {{project.profile.state}}</span>
												<span v-if="project.profile.zip"> {{project.profile.zip}}</span>
											</div>
										</div>
									</div>
									<div v-else-if="col.key == 'prj_manager'">
										<div class="sellerAssign" @click="openModal('chosseProjectManager', project)" :key="project.id+'prjManager-'+pushPrjManager">
											<div class="label-assign" v-if="project.prj_manager && project.manager">
												<div  :class="['avatarUser', (project.manager.avatar!=null) ? 'avatarImg' : '']" :style="(project.manager.avatar==null) ? 'background-color:'+project.manager.classColor+';' : ''"
												>
													<img v-if="project.manager.avatar" :src="project.manager.avatar" class="imgAvatar">
													<span class="labelAvatar" v-else>
														{{project.manager.pref_name}}
													</span>
												</div>
												<div class="text-center" style="font-size:12px;">
													{{project.manager.firstname}} {{ project.manager.lastname }}
												</div>
											</div>
											<div class="label-assign " v-else>
												<!-- bg-avatar-admin bg-avatar -->
												<span class="avatarUser bg-avatar-choise">
													<span class="labelAvatar">
														<i class="fas fa-user"></i>
														<span class="plus-user">+</span>
													</span>
												</span>
											</div>
										</div>
									</div>
									<div v-else-if="col.key == 'sow'" class="cell-sow">
										<div class="preview_sow" v-if="project.sale.sow!=null" v-html="project.sale.sow" @click="openModal('scopeOfWork', project)"></div>
										<div v-else class="files_drive" style="margin-top: 5px;">
											<span :class="['btnsimple', 'filesSOW', 'showTootlip']" @click="openModal('scopeOfWork', project)">
												Create Scope of Work
												<i class="fas fa-file-alt"></i>
												<span class="tooltip">SOW</span>
											</span>
										</div>
									</div>
									<div v-else-if="col.key == 'open'">
										<div class="btnsimple btnOpenProject showTootlip" @click="openModal('profile', project)">
											<i class="fas fa-expand-alt"></i>
										</div>
									</div>
									<div v-else-if="col.key == 'profit'">
										<div class="btnsimple btnProfit total">
											Total:
											<span style="margin-left: 5px;">9,999,999.00</span>
										</div>
										<div class="btnsimple btnProfit expenses">
											Expenses:
											<span style="margin-left: 5px;">9,999,999.00</span>
										</div>
										<div class="btnsimple btnProfit profit2">
											Profit:
											<span style="margin-left: 5px;">9,999,999.00</span>
										</div>
									</div>
									<div v-else-if="col.key == 'status'">
										<span
											:class="['badge',
												project.status_id == 1 ? 'badge-warning' :
													project.status_id == 2 ? 'badge-info' :
														project.status_id == 3 ? 'badge-success' :
															'badge-secondary'
											]">
											{{ project.current_status.name }}
										</span>
									</div>
									<div v-else>{{ project[col.key] }}</div>
								</template>
							</td>
						</tr>
					</tbody>
					<tfoot style="display:none;">
						<tr>
							<td :colspan="columns.length" class="tfoot-control">
								<div class="tfoot-content">
									<div class="tfoot-item">
										Rows:
										<select v-model="rowsPerPage" @change="changeRowsPerPage">
											<option v-for="opt in [5, 10, 25, 50, 100]" :key="opt" :value="opt">
												{{ opt }}
											</option>
										</select>
									</div>
									<div class="tfoot-item">
										Page:
										<select v-model="currentPage">
											<option v-for="n in totalPages" :key="n" :value="n">
												{{ n }}
											</option>
										</select>
									</div>
									<div class="tfoot-item view-record">
										View {{ paginatedRows.length }} of {{ projectList.length }}
									</div>
								</div>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
        <!-- modal lateral-->
        <modalLateral>
            <component v-bind:is="m.component" ></component>
        </modalLateral>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import DropdownMenu from '@/core/components/DropdownMenu.vue'
import modalLateral from '@/core/plugins/themeModalLateral/modalLateral';
import profile from "@/apps/Marketea/components/Sales/profile.vue";
import gallery from "@/apps/Marketea/components/Sales/galleryBox.vue";
import notes from "@/apps/Marketea/components/Sales/notes.vue";
import adjuntarPdf from '@/apps/Marketea/components/Sales/adjuntarPdf'
import adjuntarLinkFiles from '@/apps/Marketea/components/Sales/adjuntarLinkFiles'
import scopeOfWork from "@/apps/Marketea/components/Sales/scopeOfWork.vue";
import chosseProjectManager from "@/apps/projects/components/chosseProjectManager.vue";
import updateDataList from '@/apps/billing/views/invoice/js/methods/updateDataList.js';
import '../assets/tableProjectsGeneral.scss';
export default {
	name: 'projectsDash',
	components: {
		DropdownMenu,
		modalLateral,
		profile,
		gallery,
		notes,
		adjuntarPdf,
		adjuntarLinkFiles,
		scopeOfWork,
		chosseProjectManager
	},
	data() {
		return {
			mainDropdownOpen: false,
			settingsDropdownOpen: false,
			columns: [
				{ key: "note", label: "Project Duration", class: 'note', editable: false },
				{ key: "images", label: "Media", class: 'images text-center', editable: false },
				{ key: "client", label: "Project Info", class: 'client text-left', editable: false },
				{ key: "prj_manager", label: "Prj. Manager", class: 'prj_manager ', editable: false },
				{ key: "sow", label: "Scope of Work", class: 'sow ', editable: false },
				{ key: "profit", label: 'Profit', class: 'profit ', editable: false },
				{ key: "status", label: "Status", class: 'status text-center', editable: false },
				{ key: "open", label: "Open", class: 'open text-center', editable: false },
			],
			selected: {
				row: null,
				col: null,
				editing: false
			},
			// projectList: [
			// 	...Array.from({ length: 90 }).map((_, i) => ({
			// 		id: `${i + 1}`,
			// 		note: { daysAgo: i % 7, times: i % 5 + 1, notes: 0, sales_id: new Date().getTime() + i },
			// 		client: `Project ${i + 1}`,
			// 		images: [],
			// 		description: `Description ${i + 1}`,
			// 		status: i % 2 === 0 ? "Active" : "Inactive"
			// 	}))
			// 	// Add more projects as needed
			// ],
			projectList: [],
			rowsPerPage: 25,
			currentPage: 1,
            m: {
                show: false,
                component: '',
                data: []
            },
			urlGallery: null,
			userlist: [],
			pushPrjManager: 0,
		};
	},
	computed: {
        ...mapGetters("core", {
			getPusher: "get_accitonPusher",
            getOpenModal: 'getOpenModal',
        }),
		totalPages() {
			return Math.ceil(this.projectList.length / this.rowsPerPage);
		},
		paginatedRows() {
			const start = (this.currentPage - 1) * this.rowsPerPage;
			const end = start + this.rowsPerPage;
			return this.projectList.slice(start, end);
		}
	},
	created() {
		this.getProjects();
		this.getUsersList();
	},
	methods: {
		getProjects() {
			window.master.post('getSalesProjects', {
				org_id: window.localorgdata,
				user_id: window.master_client,
			})
			.then((response) => {
				this.urlGallery = response.data.url;
				this.projectList = response.data.list.map(project => ({
					...project,
					note: { daysAgo: project.sale.days_ago, notes: project.notes_count, sale_id: project.sale_id },
					client: project.profile,
					description: project.sale.descip,
					title: project.sale.title,
					images: [],
					status_id: project.status,
					status_name: project.current_status.name,
					manager: this.printManager(project),
				}));
				console.log('Projects loaded', this.projectList);
			})
		},
		selectCell(rowIndex, colIndex) {
			this.selected.row = rowIndex;
			this.selected.col = colIndex;
			this.selected.editing = true;

			this.$nextTick(() => {
				const input = this.$refs.editableInput;
				if (input && input[0]) {
					input[0].focus();
					input[0].select();
				}
			});
		},
		isEditingCell(row, colIndex, column) {
			return (
				column.editable &&
				this.selected.row === row &&
				this.selected.col === colIndex &&
				this.selected.editing
			);
		},
		stopEditing() {
			this.selected.row = null;
			this.selected.col = null;
			this.selected.editing = false;
		},
		changeRowsPerPage() {
			this.currentPage = 1; // volver a la primera página
		},
		openModal(c, i){
			this.m = {
				show: true,
				component: c,
				data: {}
			};
			if(c=='adjuntarLinkFiles' || c== 'adjuntarPdf' || c=='notes'){ this.m.data = i; }
			if(c=='gallery'){ this.m.data = { id: i.sale_id, cover: i.gallery_main }; }
			if(c=='scopeOfWork'){ this.m.data = { id: i.sale_id, sow: i.sale.sow }; }
			if(c=='profile'){
				let sale = i.sale;
				sale.perfil=i.profile;
				this.m.data= {item: sale, valid: false};
			}
			if(c=='chosseProjectManager'){ this.m.data={item: i, userlist: this.userlist}; }
			this.$store.commit('core/setOpenModal', this.m);
		},
		getUsersList() {
			let t = this;
			let colors = t.$store.getters['core/get_paletaDeColores'];
			let url = "/users/" + window.master_client;
			window.master.post('usersListSec', {
				user_id: window.master_client,
				org_id: window.localorgdata,
			})
			.then((response) => {
				let r = response.data;
				t.userlist = [{
					id: r.org.id,
					account_id: r.org.account_id,
					owner: r.org.bill_company_name,
					firstname: r.org.bill_firstname,
					lastname: r.org.bill_lastname,
					email: r.org.bill_email,
					pref_name: r.org.pref_name + ' ' + r.org.pref_lastname,
					pref_email: r.org.pref_email,
					classColor: (r.org.color) ? ((r.org.color != '') ? (r.org.color) : '#031099') : '#031099',
					avatar: null,
				}];
				for (let i in r.users) {
					if (r.users[i]) {
						t.userlist.push({
							id: r.users[i].id,
							account_id: r.users[i].account_id,
							owner: r.org.bill_email,
							firstname: r.users[i].firstname,
							lastname: r.users[i].lastname,
							email: r.users[i].email,
							pref_name: r.users[i].pref_name + ' ' + r.users[i].pref_lastname,
							pref_email: r.users[i].pref_email,
							classColor: (r.users[i].color) ? ((r.users[i].color != '') ? (r.users[i].color) : colors[i]) : colors[i],
							avatar: (r.users[i].avatar) ? r.users[i].ruta + r.users[i].avatar : null,
						});
					}
				}
				//console.log('usersListSec', t.userlist)
			})
			.catch((error) => {
				console.log(error);
			});
		},
		printManager(i){
			return this.userlist.find(r => { return r.account_id == i.prj_manager});
		}
	},
	watch: {
		getPusher: function(){
            let t = this;
            if (t.getPusher != undefined) {
                let token = localStorage.getItem('access_token_m');
                let oauth_m = localStorage.getItem('oauth_m');
                if(t.getPusher.action == "tableProjects" && t.getPusher.data.org_id == window.localorgdata){
					if(t.getPusher.data.action=="setPrjManager"){
						console.log(t.getPusher.data.action, t.getPusher.data);
						let manager = this.printManager(t.getPusher.data)
						console.log('manager', manager)
						this.$set(t.projectList.find(r => { return r.sale_id == t.getPusher.data.sale_id}), 'manager', manager);
						this.$set(t.projectList.find(r => { return r.sale_id == t.getPusher.data.sale_id}), 'prj_manager', t.getPusher.data.prj_manager);
						this.pushPrjManager++;
					}
                }
            }
        },
	}
};
</script>
<style scoped lang="scss">
@import '../assets/tableProject.scss';
</style>
